import React from "react";
import Layout from "./components/Layout";
import "./styles/main.scss";
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
// Main App Component
const App = () => (
  <div>
    <Layout />
  </div>
);

export default App;
